import Icon from './Document.svg';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { forwardRef } from 'react';

export const DocumentIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  function DocumentIcon(props, ref) {
    return <SvgIcon ref={ref} {...props} component={Icon} />;
  }
);
